module.exports = __webpack_public_path__ + "img/logo.b8ebd616.svg";